export default __webpack_public_path__ + "static/media/wink-trans-selected.299ed9d6.svg";